import retrieveWorkflow from 'app/modules/workflowButtonConfig/sagas/retrieveWorkflow';
import retrieveWorkflows from 'app/modules/workflowButtonConfig/sagas/retrieveWorkflows';
import retrieveSubdispositions from 'app/modules/workflowButtonConfig/sagas/retrieveSubdispositions';
import createWorkflow from 'app/modules/workflowButtonConfig/sagas/createWorkflow';
import editWorkflow from 'app/modules/workflowButtonConfig/sagas/editWorkflow';
import deleteWorkflow from 'app/modules/workflowButtonConfig/sagas/deleteWorkflow';

const sagaRegistry = [
  retrieveWorkflow,
  retrieveWorkflows,
  retrieveSubdispositions,
  createWorkflow,
  editWorkflow,
  deleteWorkflow,
];

export default sagaRegistry;
